import { render, staticRenderFns } from "./ContaBancaria.vue?vue&type=template&id=dbeb6f46&"
import script from "./ContaBancaria.vue?vue&type=script&lang=js&"
export * from "./ContaBancaria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports